import { AXIOS_INSTANCE } from '@axios/mutator/custom-instance';

const setAuthorizationHeaderInterceptor = () => {
  AXIOS_INSTANCE.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
};
export default setAuthorizationHeaderInterceptor;
